import FlagsComponentRouter from './component'
export default FlagsComponentRouter
